// removed by extract-text-webpack-plugin
module.exports = {"container":"YMcQMFEUgPa3F9xT--GR1","title":"_2nJ3WeGnb-cwtRf745PNwh","pickBtn":"_3HH-l6YE8B3jA2mCv1fTuc"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Settings/Signature/Text/styles.css
// module id = 2560
// module chunks = 0